import _extends from "reshow-runtime/es/helpers/extends";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React from 'react';
import { mixClass } from 'class-lib';
import Header from '../molecules/Header';
import SemanticUI from '../molecules/SemanticUI';

var Message = function Message(props) {
  var header = props.header,
      className = props.className,
      children = props.children,
      messageType = props.messageType,
      reset = _objectWithoutProperties(props, ["header", "className", "children", "messageType"]);

  var classes = mixClass(className, {
    info: messageType === 'info',
    error: messageType === 'error',
    success: messageType === 'success',
    warning: messageType === 'warning'
  }, 'message');
  var thisHeader;

  if (header) {
    thisHeader = /*#__PURE__*/React.createElement(Header, null, header);
  }

  return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, reset, {
    className: classes
  }), thisHeader, children);
};

export default Message;